export const isNullOrEmpty = (s: string | null | undefined): boolean =>
  s === null || s === undefined || s.length === 0

export const stringOrDefault = (
  s: string | null | undefined,
  d: string,
): string => {
  if (s === null || s === undefined || s.length === 0) {
    return d
  }
  return s
}
